<template>
    <div>
        <vue-plyr ref="plyr" :options="options">
            <video :poster="poster" :src="video_url" x5-playsinline="true" webkit-playsinline="true" playsinline="true" x5-video-player-type="h5"></video>
        </vue-plyr>
        <v-card>
            <v-card-title primary-title>
                <div>
                    <h3 class="headline pb-4">{{ title }}</h3>
                </div>
            </v-card-title>
            <expandable-text :text="description"></expandable-text>
            <v-divider light></v-divider>
            <v-card-title>
                <div>
                    <div class="headline pb-2">
                        <v-icon size="28px" class="mr-2">done_outline</v-icon>
                        现在就开始挑战
                    </div>
                    <span>恭喜你遇见【最好的自己】，获得TA赠送给你的陪伴成长积分200分。现在就开始你的免费挑战吧。你是最棒的！</span>
                </div>
            </v-card-title>
            <v-card-actions class="pb-4">
                <v-btn @click="goTo('challenge')" color="primary">查看挑战</v-btn>
                <v-btn flat @click="goTo('faq')" color="primary">常见问题</v-btn>
            </v-card-actions>
        </v-card>
        <follow-us></follow-us>
    </div>
</template>

<script>
    import {getMyIntro, setMyIntro} from '@/api/intro'
    import ExpandableText from '@/components/ExpandableText'
    import FollowUs from '@/components/FollowUs'

    export default {
        data() {
            return {
                poster: 'http://img.aiata.cn/assets/cover.png',
                title: '',
                video_url: '',
                question: '',
                description: '',
                answer: '',
                options: {
                    settings: [],
                    fullscreen: {enabled: true, fallback: true, iosNative: true}
                }
            }
        },
        components: {
            ExpandableText,
            FollowUs
        },
        created() {

        },
        mounted() {
            getMyIntro().then(data => {
                this.poster = data.poster
                this.value = data.answer
                this.video_url = data.video_url
                this.title = data.title
                this.description = data.description
                this.question = data.question
                this.answer = data.answer
                this.$store.dispatch('HideLoading')
            })
        },
        computed: {
            player() {
                return this.$refs.plyr.player
            },
        },
        methods: {
            goTo(page) {
                this.$router.push({name: page})
            }
        }
    }
</script>

<style lang="scss">
.start {
    border-radius: 0;
}
</style>
